export const ROLE_OPTIONS = [
  { label: 'Basic', value: 'basic', description: 'Access to smaller models & simpler rooms.' },
  {
    label: 'Advanced',
    value: 'advanced',
    description: 'Access to bigger models & more complex rooms.',
  },
];
